import querystring, { type ParsedUrlQueryInput } from 'querystring';
import type { HotelOffersResponse, HotelResponse, OfferResponse, OffersResponse } from '@/interfaces';

const apiFetch = async <T>(url: string): Promise<T | null> => {
    const response = await fetch(url);
    if (response.status === 304) {
        return null; // Not modified
    }
    if (!response.ok) {
        throw new Error(`(${response.status}) ${response.statusText}`);
    }
    return response.json();
};

export const fetchOffers = async (baseUrl: string, params: ParsedUrlQueryInput = {}): Promise<OffersResponse | null> => {
    const query = querystring.stringify(params);
    const url = `${baseUrl}/offers${query ? `?${query}` : ''}`;
    return apiFetch<OffersResponse>(url);
};

export const fetchOffer = async (baseUrl: string, params: ParsedUrlQueryInput = {}): Promise<OfferResponse | null> => {
    const query = querystring.stringify(params);
    const url = `${baseUrl}/offer${query ? `?${query}` : ''}`;
    return apiFetch<OfferResponse>(url);
};

export const fetchOffersForHotel = async (baseUrl: string, params: ParsedUrlQueryInput = {}): Promise<HotelOffersResponse | null> => {
    const { hotelId, ...rest } = params;
    const query = querystring.stringify(rest);
    const url = `${baseUrl}/hotel/offers/${encodeURIComponent(hotelId as string)}${query ? `?${query}` : ''}`;
    return apiFetch<HotelOffersResponse>(url);
};

export const fetchHotel = async (baseUrl: string, params: ParsedUrlQueryInput = {}): Promise<HotelResponse | null> => {
    const { hotelId, preferredSupplier } = params;
    const url = `${baseUrl}/hotel/${encodeURIComponent(hotelId as string)}${preferredSupplier ? `?preferredSupplier=${encodeURIComponent(preferredSupplier as string)}` : ''}`;
    return apiFetch<HotelResponse>(url);
};
